module.exports = __webpack_public_path__ + "static/media/goodday_data_2.1f565c65.png";